module.exports = __webpack_public_path__ + "img/m.c38da5aa.webp";